// Fee table shown in the signup form. Amounts in USD, excluding VAT.
// price: null means "on quote". Labels are translated under app.signupForm.fees.*
export const SIGNUP_FEES = [
  { id: "onboarding", price: 50 },
  { id: "planSmall", price: 60 },
  { id: "planMedium", price: 150 },
  { id: "planCooperative", price: null },
  { id: "extraField", price: 10 },
  { id: "eudrReport", price: 25 },
  { id: "traceabilityLot", price: 10 },
  { id: "assistedEntryMonthly", price: 100 },
  { id: "assistedEntryYearly", price: 1000 },
  { id: "fieldVisit", price: 250 },
];
